import {Image} from '@/_application/core/components/ui/image';
import {getImageAssetUrl} from '@/_application/core/utils/common';
import {authorizationAtom} from '@/store/authorization-atom';
import {useAtom} from 'jotai';
import {useTranslation} from 'next-i18next';
import {useUser} from '@/framework/user';
import {Link, Text} from '@kidslabs/mario-nextjs-react-ui-core';
import {Routes} from '@/config/routes';
import styles from './mobile.user-info.module.css';
import React from 'react';
const ProfileImage = getImageAssetUrl('profile.png');

export const UserInfoMobile = () => {
    const [isAuthorized] = useAtom(authorizationAtom);
    const {t} = useTranslation('common');
    const {me} = useUser();

    return (
        <div className="flex gap-1">
            <div className="min-h-10 min-w-10">
                <div className="flex h-full w-full items-center justify-center">
                    <Image src={ProfileImage} alt="profile" width={30} height={30} />
                </div>
            </div>

            <div className={`${isAuthorized && 'flex content-center items-center justify-center '}`}>
                <p className="text-left text-xs text-KPZ_text_1st">
                    {t('text-hello', 'Xin chào')},{' '}
                    <strong className={styles.name}>{isAuthorized ? me?.info?.lastname : 'Bạn'}!</strong>
                </p>
                {!isAuthorized && (
                    <div className="align-center mt-1 flex items-center gap-1">
                        <Link href={Routes.auth} aria-label="Đăng nhập với tư cách khách" className={styles.link}>
                            <Text className={styles.textLink}>{t('text-login', 'Đăng nhập')}</Text>
                        </Link>
                        <Link href={Routes.auth} aria-label="Đăng kí với tư cách khách" className={styles.link}>
                            <Text className={styles.textLink}>{t('text-register', 'Đăng ký')}</Text>
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
};
